/* RESPONSIBLE TEAM: team-standalone */

import Controller from '@ember/controller';

export default class FrameLoginController extends Controller {
  declare model: { redirect_url: string };
  queryParams = ['app_id', 'unauthorized_login_method_detected'];

  app_id = null;
  unauthorized_login_method_detected = false;
}
